import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import arrowImage from '~/static/images/arrow.svg';

export const Ask = styled.div<{ isOpen?: boolean }>`
    ${props => props.isOpen ? FONTS.MediumXS : FONTS.XS};
    cursor: pointer;
    border-bottom: 1px dotted;
    flex-wrap: nowrap;
    color: ${COLORS.ButtonWhite};
    
    &::after{
        background-color: ${COLORS.BgMain};
        mask: url(${arrowImage}) no-repeat  50% 50%;
        content: '';
        width: 15px;
        height: 15px;
        margin: 4px 8px;
        background-size: cover;
        transition: 0.25s;
        transform: ${props => props.isOpen ? 'rotate(270deg)' : 'rotate(90deg)'};
    }
    &:hover{
        color: ${COLORS.ButtonAccent};
        &::after{
            background-color: ${COLORS.ButtonAccent};
        }
    }
`;

export const Response = styled.div`
    ${FONTS.XS};
    padding-left: 30px;
    padding-top: 10px;
    overflow: hidden;
    height: auto;
    transition: 0.25s;
`;

export const Ul = styled.ul`
    margin-top: 8px;
`;

export const Li = styled.li`
    margin-bottom: 8px;
    
    ::before {
        content: "•";
        color: ${COLORS.ButtonAccent};;
        margin-right: 10px;
    }
`;
